<template>
  <div class="home">
    <img alt="TMC logo" src="../assets/logo.png" class="img-fluid pt-md-5">
    <HelloWorld class="welcome mt-md-5 mt-3 pt-md-3" msg="Dr Małgorzata Beata Wiśniewska"/>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  // name: 'home',
  components: {
    HelloWorld
  }
}
</script>
<style lang="scss" scoped>
.welcome {
  font-weight: 300;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
